import React, { useEffect } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { options } from 'components/common/GlobalFiltersInPage/components/StatusFilter/StatusFilter.consts';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { IActivityType } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import { Select } from 'components/DesignSystem/Select';

type Option = {
    value: string;
    label: string;
};

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: IActivityType[];
    isSelected?: boolean;
}

export const StatusFilter = ({ name, methods, filtersStatusRef, handleFilters, value, isSelected = true }: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    const handleChange = (selected: readonly ISelectOption<string>[]) => {
        methods?.setValue(
            name,
            selected.map((option) => option.value),
        );
        handleFilters && handleFilters();
    };

    const handleValue = (formValue?: string[]): Option[] => {
        const result: Option[] = [];
        if (!formValue?.length) return result;

        options.forEach((listOptionElement: Option) => {
            const currentFormValueElement = formValue.find(
                (formValueElement) => formValueElement === listOptionElement.value,
            );

            if (currentFormValueElement) {
                result.push(listOptionElement);
            }
        });

        return result;
    };

    return isSelected ? (
        <div className={classes.selectWrapper}>
            <div data-testid={'status-filter'} className={classes.activityCodesSelectWrapper}>
                <Controller
                    render={({ field }) => (
                        <Select<ISelectOption<string>, true>
                            {...field}
                            options={options}
                            isMulti
                            id={'battlecards-filters-status'}
                            value={handleValue(value)}
                            onChange={handleChange}
                            hideSelectedOptions={true}
                            label={FilterLabels.STATUS_CARD_BOARD}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    ) : null;
};
